/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SignalRuleAlarmState
 */
export interface SignalRuleAlarmState {
  /**
   *
   * @type {string}
   * @memberof SignalRuleAlarmState
   */
  name: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof SignalRuleAlarmState
   */
  lastSuccessTimestamp: OffsetDateTime;
  /**
   *
   * @type {number}
   * @memberof SignalRuleAlarmState
   */
  errorThresholdHours?: number | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof SignalRuleAlarmState
   */
  alarmSilencedUntilTimestamp?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof SignalRuleAlarmState
   */
  requiresActiveShipmentsCarrierIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof SignalRuleAlarmState
   */
  requiresActiveShipmentsServiceIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof SignalRuleAlarmState
   */
  carrierIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof SignalRuleAlarmState
   */
  serviceType?: string | null;
  /**
   *
   * @type {number}
   * @memberof SignalRuleAlarmState
   */
  businessDayThreshold: number;
  /**
   *
   * @type {number}
   * @memberof SignalRuleAlarmState
   */
  businessDaysCount?: number | null;
  /**
   *
   * @type {string}
   * @memberof SignalRuleAlarmState
   */
  ruleTriggered: string;
  /**
   *
   * @type {boolean}
   * @memberof SignalRuleAlarmState
   */
  neverQuoted: boolean;
  /**
   *
   * @type {string}
   * @memberof SignalRuleAlarmState
   */
  lastLiveShipmentId?: string | null;
  /**
   *
   * @type {string}
   * @memberof SignalRuleAlarmState
   */
  lastDeliveredShipmentId?: string | null;
}

/**
 * Check if a given object implements the SignalRuleAlarmState interface.
 */
export function instanceOfSignalRuleAlarmState(
  value: object,
): value is SignalRuleAlarmState {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (
    !("lastSuccessTimestamp" in value) ||
    value["lastSuccessTimestamp"] === undefined
  )
    return false;
  if (
    !("businessDayThreshold" in value) ||
    value["businessDayThreshold"] === undefined
  )
    return false;
  if (!("ruleTriggered" in value) || value["ruleTriggered"] === undefined)
    return false;
  if (!("neverQuoted" in value) || value["neverQuoted"] === undefined)
    return false;
  return true;
}

export function SignalRuleAlarmStateFromJSON(json: any): SignalRuleAlarmState {
  return SignalRuleAlarmStateFromJSONTyped(json, false);
}

export function SignalRuleAlarmStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SignalRuleAlarmState {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"],
    lastSuccessTimestamp: json["lastSuccessTimestamp"],
    errorThresholdHours:
      json["errorThresholdHours"] == null
        ? undefined
        : json["errorThresholdHours"],
    alarmSilencedUntilTimestamp:
      json["alarmSilencedUntilTimestamp"] == null
        ? undefined
        : json["alarmSilencedUntilTimestamp"],
    requiresActiveShipmentsCarrierIdentifier:
      json["requiresActiveShipmentsCarrierIdentifier"] == null
        ? undefined
        : json["requiresActiveShipmentsCarrierIdentifier"],
    requiresActiveShipmentsServiceIdentifier:
      json["requiresActiveShipmentsServiceIdentifier"] == null
        ? undefined
        : json["requiresActiveShipmentsServiceIdentifier"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    serviceType: json["serviceType"] == null ? undefined : json["serviceType"],
    businessDayThreshold: json["businessDayThreshold"],
    businessDaysCount:
      json["businessDaysCount"] == null ? undefined : json["businessDaysCount"],
    ruleTriggered: json["ruleTriggered"],
    neverQuoted: json["neverQuoted"],
    lastLiveShipmentId:
      json["lastLiveShipmentId"] == null
        ? undefined
        : json["lastLiveShipmentId"],
    lastDeliveredShipmentId:
      json["lastDeliveredShipmentId"] == null
        ? undefined
        : json["lastDeliveredShipmentId"],
  };
}

export function SignalRuleAlarmStateToJSON(json: any): SignalRuleAlarmState {
  return SignalRuleAlarmStateToJSONTyped(json, false);
}

export function SignalRuleAlarmStateToJSONTyped(
  value?: SignalRuleAlarmState | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    lastSuccessTimestamp: value["lastSuccessTimestamp"],
    errorThresholdHours: value["errorThresholdHours"],
    alarmSilencedUntilTimestamp: value["alarmSilencedUntilTimestamp"],
    requiresActiveShipmentsCarrierIdentifier:
      value["requiresActiveShipmentsCarrierIdentifier"],
    requiresActiveShipmentsServiceIdentifier:
      value["requiresActiveShipmentsServiceIdentifier"],
    carrierIdentifier: value["carrierIdentifier"],
    serviceType: value["serviceType"],
    businessDayThreshold: value["businessDayThreshold"],
    businessDaysCount: value["businessDaysCount"],
    ruleTriggered: value["ruleTriggered"],
    neverQuoted: value["neverQuoted"],
    lastLiveShipmentId: value["lastLiveShipmentId"],
    lastDeliveredShipmentId: value["lastDeliveredShipmentId"],
  };
}
